import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { BroadcastDetailPage } from '@/features/marketing'

export const Route = createFileRoute(
  '/_authenticated/marketing/broadcast/$broadcastId'
)({
  component: () => (
    <RequirePermission permission='marketing.read'>
      <BroadcastDetailPage />
    </RequirePermission>
  ),
})
